import { StringHelper } from '../strings/string-helper';
import { PhoneNumberDto } from '../../../../data-transfer-objects';

export const getPhoneNumberDisplayName = (phoneNumber: PhoneNumberDto) => {
  let type = phoneNumber.type;
  if (!type || type === 'not found') {
    type = 'unknown';
  }
  let labelString = StringHelper.sentenceCase(type);

  if (phoneNumber.description) labelString += ` • ${phoneNumber.description}`;
  return labelString;
};
